var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEngine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    fill: "#000",
    strokeLinecap: "round",
    d: "M5.92.504h5.822"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    fill: "#000",
    strokeLinecap: "round",
    d: "M7.884 2.284H9.81V.474H7.884z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    fill: "#000",
    strokeLinecap: "round",
    d: "M15.61 3.556V9.04"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    fill: "#000",
    strokeLinecap: "round",
    d: "M13.809 6.355h1.741"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    fill: "#000",
    strokeLinecap: "round",
    d: "M13.809 8.482V4.206c-1.161-.23-1.929-.874-2.312-1.922H5.403s-.327 1.724-1.524 1.724h-.544v1.385H1.54V4.065h-.185c-.668 0-.924.562-.924 1.256v4.382c0 .695.257 1.258.926 1.257l.183-.002V9.614l1.68.004s-.101 1.924.932 1.924h5.202c.65 0 1.276-.263 1.743-.734l.88-.887a1.06 1.06 0 0 1 .753-.316c.596 0 1.08-.503 1.08-1.123z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m7.612 4.077-1.97 3.751H6.81l-1.483 2.658 4.07-3.37h-1.63l2.86-3.039z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngine);
export default __webpack_public_path__ + "static/media/engine.fe4f2e3d050e5e2339b24e2e896e86fe.svg";
export { ForwardRef as ReactComponent };